import type { AnimationVariant, PreviewCommand } from '@game-platform/pack-animation';
import { PreviewCommands } from './PreviewCommands';
import type { SaveMessage } from './useSaveStatus';

interface Props {
  variant: AnimationVariant;
  hasOptions: boolean;
  message: SaveMessage | null;
  busy: boolean;
  canSave: boolean;
  /** Names where Save writes: all packs or one pack. */
  saveLabel: string;
  onCommand: (command: PreviewCommand) => void;
  onResetPreview: () => void;
  onResetOptions: () => void;
  onSave: () => void;
}

/** The top bar's right side: drive the preview, drop tuned knobs, save. */
export function PreviewActions({ message, busy, canSave, saveLabel, onSave, ...commands }: Props) {
  return (
    <>
      <PreviewCommands {...commands} />
      {message && (
        <span
          className={`font-mono text-[11px] ${
            message.type === 'success' ? 'text-emerald-400' : 'text-red-400'
          }`}
        >
          {message.text}
        </span>
      )}
      <button
        type="button"
        onClick={onSave}
        disabled={!canSave}
        className="h-7 inline-flex items-center justify-center rounded border border-emerald-600 bg-emerald-600 px-3 font-mono text-[11px] font-semibold text-white outline-none transition-colors hover:bg-emerald-500 disabled:cursor-not-allowed disabled:opacity-50"
      >
        {busy ? 'Saving...' : saveLabel}
      </button>
    </>
  );
}
